// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes, Component} from 'react';
import { connect } from 'react-redux';

// components
import Navigation from './Navigation';
import UserMenu from './UserMenu';
import CorkBoard from './CorkBoard';

import * as ui from '../../redux/actionCreators/sync/ui';


@connect()
export default class AdminLanding extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    params  : PropTypes.object,
    location: PropTypes.object.isRequired,
    children: PropTypes.object
  }

  componentDidUpdate() {
    this.props.dispatch(ui.hideSpinner());
  }

  render() {
    const showMenus = !(this.props.params.jobId || this.props.params.contactId || this.props.params.companyId || this.props.params.profileId);
    return (
      <div className='admin-landing'>
        {showMenus
          &&
          <div>
            <UserMenu dispatch={this.props.dispatch} />
            <Navigation location={this.props.location} />
          </div>
        }
        {this.props.children}

        {showMenus
          &&
          <CorkBoard />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/index.js